import { render, staticRenderFns } from "./platformHome.vue?vue&type=template&id=e7d12e8c&scoped=true&"
import script from "./platformHome.vue?vue&type=script&lang=js&"
export * from "./platformHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d12e8c",
  null
  
)

export default component.exports